<!-- @format -->
<template>
    <span v-if="post">
        <a :href="theLink" data-toggle="tooltip" data-placement="bottom" title="Share on Email" @click="trackIt">
            <span class="icon na-icon-span na-icon-email">
                <fa-icon icon="envelope-open" />
            </span>
        </a>
    </span>
</template>

<script>
import { mapGetters } from 'vuex';
import { postMixin } from '@/mixins/PostMixin.js';

export default {
    mixins: [postMixin],

    props: {
        post: {
            default: function () {
                return null;
            }
        }
    },

    data() {
        return {};
    },

    computed: {
        ...mapGetters({
            mainPublicationName: 'publication/mainPublicationName',
            mainPublicationUrl: 'publication/mainPublicationUrl'
        }),
        theLink() {
            return this.targetLink();
        }
    },

    methods: {
        targetLink() {
            const postName = this.post.directLinkShort
                ? this.post.directLinkShort
                : this.postLinkUrl(this.postGetFirstIdentifier(this.post.post_identifiers), true);
            const text =
                'I thought you would enjoy this article from ' +
                this.mainPublicationName +
                '! (' +
                this.mainPublicationUrl +
                ')';
            return 'mailto:?subject=' + encodeURI(text) + '&body=' + postName;
        },
        trackIt() {
            this.$emit('shared', {
                shareTo: 'shareToTypeEmail',
                url: this.targetLink()
            });
        }
    }
};
</script>
